var _module = require('./index');
var states = require('./states');
var _ = require('lodash');
require('../events');

_module.controller('GetFinancedCtrl', [
    'mortgageCalculatorService',
    '$listing',
    '$anchorScroll',
    '$location',
    '$events',
    'sliderConfig',
    function(mortgageCalculatorService, $listing, $anchorScroll, $location, $events, sliderConfig) {
        var vm = this;

        vm.sliderConfig = sliderConfig;
        var defaultDownPaymentPercentageOptions = [
            { label: '5%', value: 0.05 },
            { label: '10%', value: 0.10 },
            { label: '15%', value: 0.15 },
            { label: '20%', value: 0.2 }
        ];

        vm.model = {
            helpOption: null,
            currentIndex: 0,
            isLoading: true,
            homePrice: null,
            downPayment: null,
            downPaymentPercentage: null,
            loanType: '',
            interestRate: null,
            propertyTaxes: null,
            hoaDues: null,
            hoi: null,
            hoiPercentage: null,
            hoiPercentageAverage: null,
            hoiPercentageAverageDefault: null,
            mortgageInsurance: null,
            state: null,
            loanTypeOptions: [
                '30 Year Fixed',
                '15 Year Fixed',
                '5/1 ARM'
            ],
            downPaymentPercentageOptions: defaultDownPaymentPercentageOptions
        };

        vm.services = {
            calculator: new mortgageCalculatorService.Calculator(vm.model)
        };

        vm.events = {
            onDownPaymentUpdate: onDownPaymentUpdate,
            onDownPaymentPercentageUpdate: onDownPaymentPercentageUpdate,
            onLoanTypeUpdate: onLoanTypeUpdate,
            onPrequalifyClick: onPrequalifyClick,
            onResetClick: onResetClick,
            onInteraction: onInteraction
        };
        function onInteraction() {
            $events.track('Payment Calculator Interaction');
        }
        function setDefaultData() {
            console.log($listing.directMatch);
            var stateCode = _.get(vm, 'report.addressParts.state', '').toUpperCase();
            vm.model.state = _.find(states, { abbr: stateCode });
            vm.model.homePrice = reportPrice();
            vm.model.loanType = vm.model.loanTypeOptions[0];
            vm.model.downPaymentPercentage = 0.2;
            vm.model.downPayment = reportPrice() * vm.model.downPaymentPercentage;
            vm.model.interestRate = vm.services.calculator.getInterestRateForLoanType();
            vm.model.hoiPercentage = vm.services.calculator.getHOIRate();
            vm.model.hoiPercentageAverage = vm.services.calculator.getHOIRate();
            vm.model.hoiPercentageAverageDefault = vm.services.calculator.getHOIRate();
            if(vm.model.hoiPercentage) vm.model.hoi = vm.services.calculator.hoiValueForCurrentPercentage(reportPrice());
            if($listing.directMatch && $listing.directMatch.taxes) {
                vm.model.propertyTaxes = $listing.directMatch.taxes.amount;
            } else {
                vm.model.propertyTaxes = null;
            }

            vm.model.hoaDues = null;
            vm.model.hoaDuesPeriod = 'month';

            var directMatch = $listing.directMatch;
            if(directMatch && directMatch.hoa_fees && directMatch.hoa_fees.currencyPeriod && directMatch.hoa_fees.value) {
                var currencyPeriod = $listing.directMatch.hoa_fees.currencyPeriod.toLowerCase();
                if (currencyPeriod === 'month' || currencyPeriod === 'monthly'  ) {
                    vm.model.hoaDues = $listing.directMatch.hoa_fees.value;
                    vm.model.hoaDuesPeriod = 'month';
                } else if (currencyPeriod === 'annually') {
                    vm.model.hoaDues = $listing.directMatch.hoa_fees.value;
                    vm.model.hoaDuesPeriod = 'year';
                } else if (currencyPeriod === 'quarterly') {
                    vm.model.hoaDues = $listing.directMatch.hoa_fees.value;
                    vm.model.hoaDuesPeriod = 'quarter';
                }
            }

            vm.model.mortgageInsurance = null;
            vm.model.downPaymentPercentageOptions = defaultDownPaymentPercentageOptions;
        }

        function onDownPaymentUpdate() {
            onInteraction();
            vm.model.downPaymentPercentage = Math.round((vm.model.downPayment / reportPrice()) * 100) / 100;
            var label = Math.round(vm.model.downPaymentPercentage * 10000) / 100;
            var newOption = { value: vm.model.downPaymentPercentage, label: label + '%'};
            var newOptions = defaultDownPaymentPercentageOptions.concat([newOption]).sort(function(first, second) {
                return first.value - second.value;
            });
            vm.model.downPaymentPercentageOptions = newOptions;
        }

        function onDownPaymentPercentageUpdate() {
            onInteraction();
            vm.model.downPayment = reportPrice() * vm.model.downPaymentPercentage;
            vm.model.downPaymentPercentageOptions = defaultDownPaymentPercentageOptions;
        }

        function onLoanTypeUpdate() {
            onInteraction();
            vm.model.interestRate = vm.services.calculator.getInterestRateForLoanType();
        }

        function onPrequalifyClick() {

            $events.track('Get Prequalified Click');
            /*
                When a user clicked in the Get-Prequalified button in iOS Safari, 
                when the scroll to the form ended, the mobile phone input was always focused. 
                For some reason, placing the instruction that does the scroll inside a setTimeout callback fixed this. 
                I’m not sure why this works but it was the only solution found 
            */
            if (vm.isMobile) {
                setTimeout(function(){
                    document.getElementById('mobile-lender-slide').scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
                },100);
            } else {
                vm.model.currentIndex = 1;
            }
            vm.model.helpOption = 'Getting pre-approved';
        }

        function onResetClick() {
            vm.events.onInteraction();
            setDefaultData();
        } 

        function reportPrice() {
            if (vm.report && !_.isEmpty(vm.report.price_amount)) {
                var priceAmount = vm.report.price_amount.replace(/,/g, '');
                return parseFloat(priceAmount);
            }
        }

        function init() {
            mortgageCalculatorService
                .isReadyPromise
                .then(function() {
                    setDefaultData();
                })
                .finally(function() {
                    vm.model.isLoading = false;
                });
        }

        init();
    }
]);

_module.directive('getFinanced', [
    function() {
        return {
            scope: {
                report: '=',
                isMobile: '=',
                cardsResponsiveBreakpoints: '='
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: 'GetFinancedCtrl',
            restrict: 'E',
            templateUrl: 'js/components/modals/templates/get-financed.tmpl.html'
        };
    }
]);
